import { useState, useRef, useEffect, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import SelectBox from '../../shared/controls/form/selectBox';
import { TextArea, TextBox } from '../../shared/controls/form';
import TruncatedText from '../../shared/component/TruncateText';
import { Button, Modal } from 'rsuite';

import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import PriceForm from './priceForm';
import apiServices from '../../services/service';
import CommonProductList from '../sharedChild/commonList/product/commonProductList';
import ChildAccount from '../sharedChild/childAccount';
import Loader from '../../shared/component/Loader';
import Notes from '../sharedChild/note/notes';
import { getPriceList, getPriceSheetById } from '../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchAccountsAndAppendToModule,
  fetchAccountsAndAppendToPriceSheet,
  fetchDetailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchProductsAndAppendToModule,
} from '../../redux/actions';
import Timeline from '../sharedChild/timeline';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';

export const ViewPricelist = () => {
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'priceSheetList');
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(storeLoading);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const priceSheetID = queryParams.get('id');
  const priceSheetList = useSelector(getPriceList);
  const dispatch = useDispatch();

  // const priceSheetLocalData = useSelector((state) => {
  //   const priceSheetId = location.state?.id || priceSheetID;
  //   return getPriceSheetById(state, priceSheetId);
  // });

  const [priceSheetLocalData, setPriceSheetLocalData] = useState({
    ...(location.state || {}),
    type: 'view',
    from: 'view',
  });
  const priceSheetStoreData = useSelector((state) => {
    const priceSheetId = location.state?.id || priceSheetID; // Use the pre-fetched `leadID`
    return getPriceSheetById(state, priceSheetId);
  });

  useEffect(() => {
    setPriceSheetLocalData((prev) => ({ ...prev, ...priceSheetStoreData }));
  }, [priceSheetStoreData]);

  useEffect(() => {
      setLoading(storeLoading);
    }, [storeLoading]);

  const refs = {
    overview: useRef(null),
    products: useRef(null),
    accounts: useRef(null),
    timeline: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -250px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  });

  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [imageUrl, setImageUrl] = useState('/assets/images/crm/add-image-placeholder.svg');
  const [formData, setFormData] = useState([]);

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }
  const navigate = useNavigate();

  const salesform = () => {
    navigate('/sales/salesOrder', {
      state: formData,
    });
  };

  const handleViewRow = (rowData) => {
    console.log('Viewing row:', rowData);
    navigate(`/sales/viewSalesOrder?id=${rowData.salesOrderNumber}`);
  };

  const handleEditPriceSheet = () => {
    navigate('/products/priceSheet/editPriceSheet', {
      state: formData,
    });
  };
  // ***********************************************

  // ****************************************

  const [selectedNote, setSelectedNote] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);

  const handlePopupDelete = (note) => {
    setSelectedNote(note); // Store the note to delete
    setDeletePopup(true); // Open the delete confirmation popup
  };

  const handleClickDelete = () => {
    // Perform your delete logic here
    console.log('Deleting note:', selectedNote);

    // TODO: Optionally remove it from state or call an API here

    setDeletePopup(false); // Close the modal after deletion
  };
  const [updateListFlag, setUpdateListFlag] = useState(false);

  const handleCallbackGetList = () => {
    setUpdateListFlag(true);
  };

  // useEffect(() => {
  //   setLoading(true)
  //   const fetchData = async () => {
  //     if (location.pathname.includes("view")) {
  //       try {
  //         const response1 = await apiServices.getPriceListById(id);
  //         const response2 = await apiServices.getProductByPricesheetId(id);
  //         const response3 = await apiServices.getAccountByPricesheetId(id);

  //         const isAllSuccess =
  //           response1.status === 200 &&
  //           response2.status === 200 &&
  //           response3.status === 200;

  //         if (isAllSuccess) {
  //           setLoading(false)
  //           setFormData({
  //             ...response1.data?.priceSheetDetails,
  //             productAssociations: response2.data?.productPriceSheetAssociations || [],
  //             accountAssociations: response3.data?.accountPriceSheetAssociations || [],
  //             type: "view",
  //             from: "view",
  //           });
  //         } else {
  //           setLoading(false)
  //           console.error("One or more API responses failed", {
  //             response1,
  //             response2,
  //             response3,
  //           });
  //         }
  //       } catch (error) {
  //         console.error("API call error:", error);
  //       }
  //     }
  //   };
  // setUpdateListFlag(false)
  //   fetchData();
  // }, [location, id, updateListFlag]);

  useEffect(() => {
    const priceSheetId = location.state?.id || priceSheetID;

    if (location.pathname.includes('view')) {
      setFormData({
        ...priceSheetLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (priceSheetId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'PriceSheet',
          id: priceSheetId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'PriceSheet',
          id: priceSheetId,
        })
      );

      dispatch(
        fetchAccountsAndAppendToPriceSheet({
          moduleName: 'PriceSheet',
          id: priceSheetId,
        })
      );
      dispatch(
        fetchProductsAndAppendToModule({
          moduleName: 'PriceSheet',
          id: priceSheetId,
        })
      );
    }
  }, [location, priceSheetLocalData?.id]);

  console.log(formData);
  return (
    <>
      {loading && <Loader />}
      <div id="viewProduct">
        <div className="viewPageOuter">
          <div className="viewHeader">
            <HeaderProfileBlock
              localData={priceSheetLocalData}
              moduleName={'PriceSheet'}
              View={true}
            />
            <div className="rightAction">
              <button className="btn btn-outline-primary" onClick={handleEditPriceSheet}>
                Edit
              </button>
            </div>
          </div>

          <div className="detailContainer">
            <div className="viewFormContainer">
              <div className="leftBlock">
                <ul>
                  {Object.keys(refs).map((key) => (
                    <li
                      key={key}
                      onClick={() => scrollToSection(key)}
                      style={{ cursor: 'pointer' }}
                      className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                    >
                      <button onClick={() => setActiveTab(key)}>{toTitleCaseFromCamel(key)}</button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rightBlock" id="detailPageRight">
                <div className="addlead_container">
                  <div id="overview" className="scrollTo" ref={refs.overview}></div>
                  <PriceForm formData={priceSheetLocalData} />
                  <div id="products" className="scrollTo" ref={refs.products}></div>
                  <CommonProductList localData={priceSheetLocalData} module={'PriceSheet'} />
                  <div id="accounts" className="scrollTo" ref={refs.accounts}></div>
                  <ChildAccount localData={priceSheetLocalData} module={'PriceSheet'} />
                  <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                  <Timeline localData={priceSheetLocalData} module={'PriceSheet'} />
                </div>
              </div>
            </div>
            <div className="viewFormNotesOuter">
              <div className="ViewFormNotesContainer">
                <Notes leadLocalData={priceSheetLocalData} module={'PriceSheet'} />
              </div>
            </div>
          </div>
        </div>

        {deletePopup && (
          <Modal show={deletePopup} onHide={() => setDeletePopup(false)} className="modal-delete">
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setDeletePopup(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={() => handleClickDelete(selectedNote)}>
                Confirm Delete
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ViewPricelist;
